import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { removeHtml } from 'env/utils/strings';
@observer
class TextAreaInputField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    this.props.onChange(
      event.target.name,
      event.target.value.length > 0 ? removeHtml(event.target.value) : null
    );
  }

  render() {
    const input = this.props;
    const hasErrors = input.errors && input.errors.length > 0;
    return (
      <>
        <label className="control-label" htmlFor={input.id}>
          {input.label || input.name}
        </label>
        <textarea
          className={`form-control ${hasErrors ? 'validationElement' : ''}`}
          rows="3"
          id={input.id}
          name={input.name}
          onChange={this.onChange}
          value={input.value || ''}
          {...this.props.inputProps}
        ></textarea>

        {hasErrors && (
          <small className="help-block validation-error">
            {input.errors.join(', ')}
          </small>
        )}
      </>
    );
  }
}

TextAreaInputField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TextAreaInputField;
